import {classNames, React, observer, Fragment, Popover2} from '@api'
import {Icon, Menu, MenuDivider, MenuItem, Popover} from '@blueprintjs/core'
import {Tooltip2} from '@api'

import {Tooltip} from '@material-ui/core'
import {AccountCircle} from '@material-ui/icons'
import {DevDeploymentsMenuItems, MenuItemsForDeployment, UpdateServerSiteStoreMenuItem, useStores} from '@modules'
import {CentricLogo, PdfSvgIcon} from '@stores/ui'
import * as css from './UserMenuDropdownIcon.css'
import {deployments, icons, nav, ui} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'

export const UserMenuDropdownIcon = observer(function UserMenuDropdownIcon() {
  const {
    config: {deployment, toggleShowNotificationsConfig},
    catalog: {dialogs},
    strings, ui: {settings}, currentUser: {toggleC8ImageSource, toggleServerPDF, userSettings, toggleLocalNest, toggleLocalSAM, toggleVirtualCatalog},
    authStore: { logout, userIsAuthenticated }, users: {user},
    deployments: {downloadCurrentConfig, uploadConfig, updateDBConfig, selectedDeployment}
  } = useStores()
  return (!userIsAuthenticated ? null :
    <Popover2
      interactionKind='hover'
      className={css.root}
      popoverClassName={css.menuPopover}
      position='bottom-right'
      minimal
      content={<Menu>
        {false && <ExportMenuItems />}
        {DEBUG &&
          <Fragment>
              <MenuItem icon='database' text='Deployments'>
                <DevDeploymentsMenuItems />
              </MenuItem>
            {selectedDeployment && <MenuItem icon='globe' text={selectedDeployment.label ?? selectedDeployment.heading ?? selectedDeployment._id}>
                <MenuItemsForDeployment deployment={selectedDeployment} />
            </MenuItem>}
            <MenuItem text='Developer' icon={icons.dev}>
              {/*{!!config.showStorybook === true && <MenuItem icon='book' className={classes.menuItem} onClick={() => window.open('http://localhost:6006')} text='Storybook'/>}*/}
	            <MenuItem icon={'database'}
	                      href={`https://vip.kb.us-west-2.aws.found.io:9243/app/dev_tools#/console`}
	                      target='_blank'
	                      text={`Open VIP (Cloud ES) Kibana`}/>
	            <MenuItem icon={'database'}
                        href={nav.kibanaUrl}
                        target='_blank'
	                      text={`Open Kibana Dev Tools`} />
                <MenuItem icon={userSettings.dev?.localNest ? 'tick' : 'blank'} shouldDismissPopover={false} text='Local Nest Server?' onClick={toggleLocalNest} />
	            <MenuItem icon={userSettings.dev?.localSAM ? 'tick' : 'blank'} shouldDismissPopover={false} text='Local SAM?' onClick={toggleLocalSAM}/>
	              <MenuItem icon={userSettings?.dev?.virtualizedCatalog ? 'tick' : 'blank'} shouldDismissPopover={false} text='Virtualized Catalog?' onClick={toggleVirtualCatalog}/>
	            <UpdateServerSiteStoreMenuItem />
                <MenuDivider />
                <MenuItem icon={nav.queryParams.mobx === null ? 'tick' : 'blank'} onClick={() => nav.updateQueryParams({mobx: nav.queryParams.mobx === null ? undefined : null})}
	                      text='MobX Debug Panel'/>

            </MenuItem>

	          {/*<ToggleNestJsServiceMenuItem/>*/}
          </Fragment>}
        <MenuItem text='QR Code' icon='barcode' onClick={() => dialogs.showQrCodeModal = true} />

        {ui?.settings?.configMenu &&
         <Fragment>
	         <MenuDivider title='Configuration'/>
	         <MenuItem text='Update Database Configuration' icon='refresh' onClick={updateDBConfig}/>
	         <MenuItem text='Save Configuration' icon='download' onClick={downloadCurrentConfig}/>
	         <MenuItem text='Upload Configuration...' icon='upload' onClick={uploadConfig}/>
         </Fragment>}

        {ui?.settings?.showUserSettings && <Fragment><MenuDivider title='User Settings'/>
        <MenuItem text='Notifications' icon='notifications' onClick={toggleShowNotificationsConfig} />
	        <MenuItem text='C8 Direct Images?' shouldDismissPopover={false} icon={userSettings?.showC8Images ? 'tick' : <CentricLogo />} onClick={toggleC8ImageSource}/>
          {DEBUG && <MenuItem text='Server-Side PDF?' shouldDismissPopover={false} icon={userSettings?.serverPDF ? 'tick' : <PdfSvgIcon/>} onClick={toggleServerPDF}/>}
        </Fragment>}
        <MenuDivider />
        <LanguageChooserMenu />
        {user && <MenuItem text={`${user.name}`}/>}
        {deployment && <MenuItem disabled text={`${deployment.title} ${deployment.version}`} />}
        <MenuDivider />
        <MenuItem className={css.menuItem} onClick={() => logout(true)} text='Logout' icon='log-out'/>
      </Menu>}>
      <Tooltip2 content={strings.account} placement='bottom'>
        <PrimaryIconButton icon={<AccountCircle />} onClick={() => {/*nyi*/ }} />
      </Tooltip2>
    </Popover2>
  )
})

const LanguageChooserMenu = observer(function LanguageChooserMenu() {
  const {strings, deployments: {deploymentConfig}, ui} = useStores()

  return deploymentConfig?.languages?.length > 1 ? (
    <MenuItem text={strings.chooseLanguage} icon='book'>
      {deploymentConfig.languages.map(
        ({label, language}) =>
          <MenuItem key={language}
                    shouldDismissPopover={false}
                    onClick={() => ui.setLang(language)}
                    icon={ui.language == language ? 'tick' : 'blank'}
                    text={label ?? language} />
          )}
  </MenuItem>
  ) : null
})

const ExportMenuItems = observer(function ExportMenuItems() {
  const {
    export: {
      onClickExport,
      exportConfig: { excel: excelConfig, images: imagesConfig }
    }, catalog: { exportConfig }
  } = useStores()

  return <MenuItem text='Export' icon='export'>
    {exportConfig?.excel && <MenuItem onClick={(e)=>onClickExport(excelConfig)} text={excelConfig.modalTitle} />}
    {exportConfig?.images && <MenuItem onClick={(e)=>onClickExport(imagesConfig)} text={imagesConfig.modalTitle} />}
  </MenuItem>
})


// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/UserMenuDropdownIcon.tsx